<div class="flex flex-col items-center justify-center min-h-screen bg-gray-900 text-white">
  <h1 class="text-9xl font-bold text-purple-500">404</h1>
  <p class="text-2xl mt-4">Oops! Page not found.</p>
  <p class="text-gray-400 mt-2">The page you're looking for doesn't exist.</p>

  <button (click)="goHome()" class="mt-6 px-6 py-3 bg-purple-600 hover:bg-purple-700 rounded-lg text-white transition shadow-lg">
    Go Home
  </button>
</div>
